import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addTerritory,
  addTerritoryTown,
  getAssignTripTypes,
  getOtherTripTypes,
  getPositionList,
  getSearchLocation,
  getTerritoryById,
  getTerritoryList,
  getTerritoryTownList,
  updateTerritory,
  updateTerritoryTown,
} from "./TerritoryRepo";
import { showToast } from "../../../utils/toastUtils";

export const useGetTerritoryList = ({
  enable = false,
  params = {},
}: {
  enable: boolean;
  params?: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_TERRITORY_LIST", params],
    queryFn: () => getTerritoryList(params),
    enabled: enable,
    retry: false,
  });
};

export const useGetTerritoryById = ({
  enable = false,
  params = {},
}: {
  enable: boolean;
  params?: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_TERRITORY_BY_ID", params],
    queryFn: () => getTerritoryById(params),
    enabled: enable,
    retry: false,
  });
};

interface UseGetPositionListProps {
  enable?: boolean;
  id: number | null;
  TerritoryId: number | null;
}

export const useGetPositionList = ({
  enable = false,
  id = null,
  TerritoryId = 0,
}: UseGetPositionListProps) => {
  return useQuery({
    queryKey: ["GET_POSITION_LIST", id],
    queryFn: () => getPositionList(id, TerritoryId),
    enabled: enable && !!id,
    retry: false,
  });
};

interface ReqBody {
  TerritoryName: string;
  Orgunitid: number | null;
  PositionId: number | null;
}
export const useAddTerritory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ ReqBody }: { ReqBody: ReqBody }) => addTerritory(ReqBody),

    onSuccess: (r:any) => {
      showToast.success(r.message);
      queryClient.invalidateQueries({ queryKey: ["GET_TERRITORY_LIST"] });
    },
    onError: (error: any) => {
      // showToast.warning(`${error.message}`);
      console.log("Somethig went wrong", error.message);
    },
  });
};

export const useUpdateTerritory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ ReqBody, TerritoryID }: { ReqBody: ReqBody; TerritoryID: number }) =>updateTerritory(ReqBody, TerritoryID),

    onSuccess: () => {
      showToast.success("Territory update Successfully");
      queryClient.invalidateQueries({ queryKey: ["GET_TERRITORY_LIST"] });
    },
    onError: (error: any) => {
      showToast.warning(error.message);
      console.log(`something went wrong ${error.message}`);
    },
  });
};



/****************************TOWN*********************************/
export const useGetTerritoryTownList = ({
  enable = false,
  params = {},
  id = null,
}: {
  enable: boolean;
  params?: Record<string, any>;
  id: number | null;
}) => {
  return useQuery({
    queryKey: ["TOWN_LIST", params,id],
    queryFn: () => getTerritoryTownList(params, id),
    enabled: enable,
    retry: false,
  });
};


export const useGetAssign_To_Tripes =({enable=false}:{enable:boolean})=>{
  return useQuery({
    queryKey:['ASSIGN_TRIP_LIST'],
    queryFn:getAssignTripTypes,
    retry:false,
    enabled:enable
  });
};


export const useGetOtersTripTypes =({enable = false}:{enable:boolean})=>{
   return useQuery({
    queryKey:['OTHERS_TRIP_TYPES'],
    queryFn:getOtherTripTypes,
    retry:false,
    enabled:enable
   })
}

export const useGetLocation = ({enable=false,userQuery=''}:{enable:boolean,userQuery:string})=>{
  return useQuery({
    queryKey:['GET_LOCATION',userQuery],
    queryFn:()=>getSearchLocation(userQuery),
    retry:false,
    enabled:enable 
  })
}

interface ReqBodyTown{
  Itownid:number,
  TerritoryId: number,
  AssignToTripType: string,
  OthersTripType: string,
  OnlyNca: boolean
}

export const useAddTerritoryTown =()=>{
  const queryClient = useQueryClient();
    return useMutation({
      mutationFn:({ReqBody}:{ReqBody:ReqBodyTown})=>addTerritoryTown(ReqBody),
      onSuccess:()=>{
        showToast.success('Territory Town Added Successfully');
        queryClient.invalidateQueries({queryKey:['TOWN_LIST']});
      },
      onError:(error:any)=>{
      showToast.warning(`Failed to add Territory Town`);
      console.log(`Something went wrong Faield to add territory Town ${error.message}`);
      }
    });
}


 interface ReqBodyUpdateIterface{
  id:number,
  Itownid: number,
  TerritoryId: number,
  AssignToTripType: String,
  OthersTripType: string,
  OnlyNca: boolean,
 }

export const useUpdateTerritoryTown =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:({ReqBody}:{ReqBody:ReqBodyUpdateIterface})=>updateTerritoryTown(ReqBody),
    onSuccess:()=>{
      showToast.success('Update Succesfully');
      queryClient.invalidateQueries({queryKey:['TOWN_LIST']});
    },

    onError :(error:any)=>{
      showToast.warning(`${error?.message}`);
      console.log('Something went Wrong while Updating Territory Town ',error?.message)
    }
   });
}
